import $ from 'jquery';
import { loadModal } from '../../AsyncLoader';
import ContentStorage, { ComponentKeys } from '../../tnew/content/ContentStorage';
import dom from '../../utils/dom';
import ForgotPasswordService from './ForgotPasswordService';

const FORM_ID = 'tn-account-login-forgot-password-form';
const { formButtonHandler } = window.tnew.handlers;
const { FieldValidationProvider } = window.tnew.lib;

class ForgotPasswordModalProvider {
  constructor(autoShow = false) {
    this.autoShow = autoShow;

    this.$modalSuccessMessage = $('#tn-account-login-forgot-password-success-message');
    this.$sendInstructions = $('.tn-send-instructions');
    this.$failureMessage = $('#tn-account-login-forgot-password-failure-message');
    this.$username = $('#ForgotLogin_Username');
    this.$resetLink = $('#tn-account-login-forgot-login-link');
    this.$form = $('#tn-account-login-forgot-password-form');
    this.$inputLoginEmail = $('#PatronAccountLogin_Username');
  }

  listen() {
    this.$resetLink.on('click', () => {
      this.setUpFormFields();
      this.showModal();
    });

    FieldValidationProvider.createStandardProvider(this.$form.id);

    if (this.autoShow) {
      this.showModal();
    }
  }

  setUpFormFields() {
    this.$failureMessage.html('');
    this.$failureMessage.hide();

    const loginEmailValue = this.$inputLoginEmail.val();

    if (loginEmailValue) {
      this.$username.val(loginEmailValue);
      this.$username.blur();
    }

    this.$sendInstructions.show();
    this.$modalSuccessMessage.hide();
  }

  async showModal() {
    let modal;

    const {
      heading,
      cancelButtonText,
      sendEmailButtonText,
      closeButtonText,
    } = this.getForgotPasswordComponentData();

    const $submitButton = this.makeModalSubmitButton(sendEmailButtonText);
    const $cancelButton = this.makeModalCancelbutton(cancelButtonText);

    $submitButton.addEventListener('click', (event) => {
      event.preventDefault();
      this.processForm($submitButton);
    });

    $cancelButton.addEventListener('click', () => {
      modal.close();
    });

    const Modal = await loadModal();

    modal = Modal.open({
      title: heading,
      bodyContents: this.$form,
      footerContents: [$cancelButton, $submitButton],
      returnFocusTo: this.$resetLink[0],
    });

    this.modal = modal;
    this.heading = heading;
    this.closeButtonText = closeButtonText;
  }

  getForgotPasswordComponentData() {
    const key = ComponentKeys.FORGOT_PASSWORD;

    return {
      heading: ContentStorage.getValue(key, 'Heading'),
      cancelButtonText: ContentStorage.getValue(key, 'CancelButtonText'),
      sendEmailButtonText: ContentStorage.getValue(key, 'SendEmailButtonText'),
      closeButtonText: ContentStorage.getValue(key, 'CloseButtonText'),
    };
  }

  makeModalSubmitButton(labelHtml) {
    const $btn = dom.makeElement('button', {
      type: 'submit',
      class: 'modal-btn-confirm btn btn-primary tn-account-login-forgot-password-button-submit',
      form: FORM_ID,
    });

    $btn.innerHTML = labelHtml;

    return $btn;
  }

  makeModalCancelbutton(labelHtml) {
    const $btn = dom.makeElement('button', {
      type: 'button',
      class: 'modal-btn-cancel btn btn-default',
    });

    $btn.innerHTML = labelHtml;

    return $btn;
  }

  processForm(submitButton) {
    const email = this.$username.val();

    if (!email) {
      this.$username.blur(); // Triggering field validation
      this.$username.focus();

      return;
    }

    formButtonHandler.applyBusyStyling(submitButton);
    this.post(email, submitButton);
  }

  async post(email, submitButton) {
    const response = await ForgotPasswordService.resetLogin(email);

    if (response.isSuccess) {
      let modal;

      this.modal.close();

      const $closeButton = this.makeModalSubmitButton(this.closeButtonText);

      $closeButton.addEventListener('click', () => {
        modal.close();
      });

      const Modal = await loadModal();

      modal = Modal.open({
        title: this.heading,
        bodyContents: this.$modalSuccessMessage,
        footerContents: $closeButton,
        returnFocusTo: this.$resetLink[0],
      });

      this.$modalSuccessMessage.show();
    } else {
      this.$failureMessage.html(response.message);
      this.$failureMessage.show();
    }

    formButtonHandler.resetStyling(submitButton);
  }
}

export default ForgotPasswordModalProvider;



// WEBPACK FOOTER //
// ./V7/account/login/ForgotPasswordModalProvider.js